import { Component, OnInit, ViewChild } from "@angular/core"
import { ValidatedSelectOptionModel } from "../../../validations/validated-dropdown.component";
import { OrgLevelGateway } from "../../../org-management/gateways/organization-gateway";
import { UserTypeGateway } from "../../../user-management/gateways/user-type-gateway";
import { OrgTreeViewMultiSelect } from "../../../common/components/orgTreeView/org-treeview-multiselect.component"

@Component({
    templateUrl: 'multiselect-org-sample.html'
})
export class MultiSelectOrgSample implements OnInit {
    
    orgIds: string[]

    ngOnInit(): void {
    }

    OnOrgSelected(event: any) {
        this.orgIds = event
		console.log('Selected Org Ids:', this.orgIds)
    }

    doSomethingWithOrgIds(): void {
        setTimeout(() => {
            console.log('Org Ids to be processed:', this.orgIds)
        }, 1500)
    }
}